import { css } from "@emotion/react";

const Footer: React.FC = () => {
  return (
    <div css={mainStyle}>
      <div css={captionStyle(16, 0, 10, 0, 600)}>
        カルチュア・エンタテインメント公式 SNS
      </div>
      <div css={iconsWrapperStyle}>
        <a
          href="https://www.instagram.com/culture_entertainment_cp_/"
          target="_blank"
          rel="noopener"
        >
          <img
            src={process.env.REACT_APP_BASE_PATH + "/img/instagram.png"}
            css={iconStyle}
          />
        </a>
        <a
          href="https://www.youtube.com/user/CulturepublishersCP"
          target="_blank"
          rel="noopener"
        >
          <img
            src={process.env.REACT_APP_BASE_PATH + "/img/youtube.png"}
            css={iconStyle}
          />
        </a>
        <a
          href="https://twitter.com/cecp_eizou/"
          target="_blank"
          rel="noopener"
        >
          <img
            src={process.env.REACT_APP_BASE_PATH + "/img/x.png"}
            css={iconStyle}
          />
        </a>
      </div>
      <a href="https://www.culture-pub.jp/" target="_blank" rel="noopener">
        <img
          src={
            process.env.REACT_APP_BASE_PATH + "/img/culture-entertainment.png"
          }
          css={companyNameImgStyle}
        />
      </a>
      <div css={captionStyle(13, 40, 10, 30)}>
        © Culture Entertainment Co.,Ltd.
      </div>
    </div>
  );
};

const spSize = 768;

const mainStyle = css`
  width: 100%;
  padding: 50px 0 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.91);

  @media (max-width: ${spSize}px) {
    padding: 30px 0 10px;
  }
`;

const captionStyle = (
  fontSize: number,
  paddingTop: number,
  fontSizeSP: number,
  pddingTopSP: number,
  fontWeight?: number,
) => css`
  font-size: ${fontSize}px;
  padding-top: ${paddingTop}px;
  font-weight: ${fontWeight ? fontWeight : 400};

  @media (max-width: ${spSize}px) {
    font-size: ${fontSizeSP}px;
    padding-top: ${pddingTopSP}px;
  }
`;

const iconsWrapperStyle = css`
  width: 208px;
  padding-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: ${spSize}px) {
    width: 130px;
  }
`;

const iconStyle = css`
  width: 52px;
  height: 52px;

  @media (max-width: ${spSize}px) {
    width: 32.5px;
    height: 32.5px;
  }
`;

const companyNameImgStyle = css`
  width: 180px;
  height: auto;
  margin-top: 30px;

  @media (max-width: ${spSize}px) {
    width: 125px;
    margin-top: 20px;
  }
`;

export default Footer;
